export default __webpack_public_path__ + "images/VN.4709a1a.png";